module.exports = __webpack_public_path__ + "media/ru_ru_s2_Igor.62220f80.oga";